
import { serviceHost } from '../../common/const';
import ServiceRequest from '../../utils/service-request';


export const saveAccountAnalysis =async (data) => {
    try {
        let response = await ServiceRequest('post','json',serviceHost +'/analysis/saveAccountAnalysis',data)
        return{response,err:null};
    }
    catch(err) {
            if(err){
                return {response:null,err}
            }
    }
}


export const saveSupplierAnalysis =async (data) => {
    try {
        let response = await ServiceRequest('post','json',serviceHost +'/analysis/saveSupplierAnalysis',data)
        return{response:response,err:null};
    }
    catch(err) {
            if(err){
                return {response:null,err}
            }
    }
}

export const getSupplierAnalysis =async (data) => {
    try {
        let response = await ServiceRequest('post','json',serviceHost +'/analysis/getSupplierAnalysis',data);
        return{response:response,err:null};
    }
    catch(err) {
        return {response:null,err};
    }
}

export const getAccountAnalysis =async (data) => {
    try {
        let response = await ServiceRequest('post','json',serviceHost +'/analysis/getAccountAnalysis',data);
        return{response:response,err:null};
    }
    catch(err) {
        return {response:null,err};
    }
}